/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Mayur Pathak",
  title: "Hi all, I'm Mayur",
  subTitle: emoji(
    "A passionate Full Stack Software Engineer 🚀  Expert in diverse programming languages, including Ruby on Rails,Angular,C#.NET,.NET MVC,Excel VBA,SQL Server."
  ),
  resumeLink:
    "https://docs.google.com/document/d/1a9saDfaNYQ4Ot2OEfIF9Ux76fFEkgc3eonYy4ChJg9I/edit?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/mayurpathak",
  linkedin: "https://www.linkedin.com/in/mayur-pathak-b25bb8153/",
  gmail: "mayurpathak888@gmail.com",
  stackoverflow: "https://stackoverflow.com/users/9793596/mayur-pathak",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA )"),
    emoji(
      "⚡ Integration of third party services such as AWS / etc.."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Ruby On Rails",
      fontAwesomeClassname: "fas fa-gem"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "C#",
      fontAwesomeClassname: "fa fa-hashtag"
    },
    {
      skillName: "Excel VBA",
      fontAwesomeClassname: "fas fa-file-excel"
    },
    { 
      skillName: "Git",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Kadi Sarva Vishwavidyalaya, Gandihnagar",
      logo: require("./assets/images/ksvlogo.png"),
      subHeader: "Master of Computer Applications - MCA",
      desc: "Studied of Software development life cycle in details.",
      descBullets: [
        "Studied various programming languages like C#, Java, HTML, ASP etc.",
        "Studied and practice the concept of Data Structures,SQL,Networking.",
        "Studied the concept of Computer based numerical and statistical mathematics.",
        "I have also completed various Project using Asp.net Mvc, C#, etc."
      ]
    },
    {
      schoolName: "Doctor Babasaheb Ambedkar Open University",
      logo: require("./assets/images/baouLogo.png"),
      subHeader: "Bachelor of Computer Applications - BCA",
      desc: "Studied the fundamentals of computers architecture, logical gates, number system, programming languages and algorithms.",
      descBullets: [
        "Studied the basic concepts of RDBMS and practiced on MySQL.",
        "Studied and learn programming using C and C++." 
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "60%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Back-End Web Development",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "SoInnovators株式会社",
      companylogo: require("./assets/images/sologo_new.png"),
      date: "Fab 2020 – Present",
      desc: "Worked with team members to improve performance and implement training updates..",
      descBullets: [
        "Work closely with the Project Manager, Client, and Team Lead on change request functions. Increased productivity and problem-solving techniques.",
        "I mostly work as a Ruby On Rails developer and Mainten Angular application and provide guidance to junior software development staff.",
        "Active Record using PostgreSQL, MySQL enhanced adapter databases.",
        "Ongoing projects maintenance.",
        "Integrate AWS SP-API(amazon selling partner Api) In Ruby On rails from scratch.",
        "Attended regular meetings with the clients for enhancing the application for the purpose of user needs."
      ]
    },
    {
      role: "Software Engineer",
      company: "Lainnovatorslab",
      companylogo: require("./assets/images/lalogo.png"),
      date: "Jul 2019 – Jan 2020",
      desc: "Software development started using new technologies Ruby On Rails and Developed also Vba Excel Tool",
      descBullets: [
        "Developed Excel VBA application that communicates with DB using ADO Objects and SQL.",
        "Developed macros to verify and compare data.",
        "Prepared program-level and user-level documentation.",
        "Experience in the development of financial applications using Excel and Access.",
        "Database modeling and design. Involved in developing and implementation of the web application using Ruby on Rails."
      ]
    },
    {
      role: ".Net Developer",
      company: "Alpslogic IT Solutions",
      companylogo: require("./assets/images/AlpsLogiclogo.png"),
      date: "Mar 2018 – Jun 2019",
      desc: "This was my first company and from there I started the career I worked mainly as a .net developer.",
      descBullets: [
        "MVC Design Pattern followed for Asp.Net MVC Application.",
        "Integrated Data Access and Exception Handling blocks for database management and error handling.",
        "Used various data controls grid view, multi view and detail views for creating user controls.",
        "Also used different approaches in Entity Framework to interact with database.",
        "Involved in design and developing of navigations control, user controls, custom control etc.",
        "Created custom SharePoint sites, sub sites, Document Libraries, Lists and List views to collaborate the Affiliates",
        "Developed the application using the 3-tier architecture."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "",
  projects: [
    {
      projectName: "EC-SHOHIN MASTER", 
      projectDesc: "Associated with SoInnovators株式会社",
      projectTechnology: "Technology: Ruby on Rails,Angular,MySQL,SSIS Script",
      projectCustomer: "Customer: Right-on",
      projectrole: "Developed new requirements, Maintenance, Customer Services, Task Management, Technical support",
      projectdescBullets: [
        "This system is used for product catalog management. It shares product details to different online stores like Right-on e-commerce site, Rakuten,magashiku, ZOZO, SHOPLIST, PAYPAY, etc.",
        "A multichannel product management system is a centralized item registration management system.",
        "Users register the Product page & information on the system.",
        "Online stores time sale creation.",
        "Every day Price data update on each Online stores.",
      ],
    },
    {
      projectName: "Product Management", 
      projectDesc: "Associated with SoInnovators株式会社",
      projectTechnology: "Technology: Ruby on rails v4.0, REST API,SQLSERVER 2018, Angular4, sidekiq",
      projectCustomer: "Customer: Right-on",
      projectrole: "Developed new requirements, Maintenance, Customer Services, TaskManagement, Technical support",
      projectdescBullets: [
        "This is a product management web application.",
        "We can register products with SKU and it's images and videos.",
        "We can place orders to purchase a manufacturer's product.",
        "Maker is verifying/checking product details and Accepting them .",
        "Dynamic deployment using NFS server to multiple Production servers. (Divide cronjob in multiple servers using Linux shell script)"
      ],
    },
    {
      projectName: "HIM (Image and video manage)", 
      projectDesc: "Associated with SoInnovators株式会社",
      projectTechnology: "Technology: Ruby on rails v4.0, REST API,SQLSERVER 2018, sidekiq",
      projectCustomer: "Customer: Right-on",
      projectrole: "Maintenance, Customer Services, Technical support",
      projectdescBullets: [
        "This is a Products Image and video management web application.",
        "Build Image processing ruby services that perform watermarking, image compression, etc,",
        "Create Image and video according to E-commers site requirement."
      ],
    },
    {
      projectName: "Analysis Group Client", 
      projectDesc: "Associated with ALPSLOGIC IT SOLUTIONS ",
      projectTechnology: "Technology: C#, javascript, Sql,Wpf",
      projectCustomer: "Customer: Analysis Group",
      projectrole: "Development,Testing & Deployment",
      projectdescBullets: [
        "This project is created into asp.net with multiple frameworks",
        "In this project, I had done to the web application in asp.net core.",
        "Also done Linux code with c#.",
        "In this project I do the wix setup for WPF application",
        "When customer login they get some",
        "page access based on admin assign like role-based access",
        "I worked on admin panel also with role and access",
        "page access based on admin assign like role-based access"
      ],
    },
  ],
  
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: ""
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: ""
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: ""
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With a love for developing good stuff, I love to write down what I've learned and teach it to others.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "",
      event_url: ""
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "",
  number: "",
  email_address: ""
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
